export type InfoFaqAction =
  | { type: 'SET_IS_FETCHING_FAQ' }
  | { type: 'SET_FETCH_FAQ_FAILED' }
  | { type: 'SET_FAQ', faqList: Julius.Website.FAQViewModel[] };

  export const setIsFetching = (): InfoFaqAction => ({
    type: 'SET_IS_FETCHING_FAQ',
  });

  export const setFetchFailed = (): InfoFaqAction => ({
    type: 'SET_FETCH_FAQ_FAILED',
  });

  export const setFaqList = (faqList: Julius.Website.FAQViewModel[]): InfoFaqAction => ({
    faqList,
    type: 'SET_FAQ',
  });


// WEBPACK FOOTER //
// ./src/components/InfoFaq/Redux/actions.tsx